<template>
    <v-chart ref="heat" :options="option"/>
</template>

<script>
    import ECharts from 'vue-echarts'
    import 'echarts/lib/chart/line'

    export default {
        name: "UserStayHeatEChert",
        components:{
            'v-chart': ECharts,
        },
        props:{
            heatMapData:Object
        },
        watch:{
            heatMapData:function (newVal, oldVal) {
                this.$refs.heat.clear();
                this.option.yAxis.data = newVal.settings.yAxis;
                this.option.series[0].data = newVal.data;


            }
        },
        data(){
            let data = [
                [0,0,0],[0,1,0],[0,2,0],[0,3,0],[0,4,0],[0,5,0],[0,6,0],
                [1,0,0],[1,1,0],[1,2,0],[1,3,0],[1,4,0],[1,5,0],[1,6,0],
                [2,0,0],[2,1,0],[2,2,0],[2,3,0],[2,4,0],[2,5,0],[2,6,0],
                [3,0,0],[3,1,0],[3,2,0],[3,3,0],[3,4,0],[3,5,0],[3,6,0],
                [4,0,0],[4,1,0],[4,2,0],[4,3,0],[4,4,0],[4,5,0],[4,6,0],
                [5,0,0],[5,1,0],[5,2,0],[5,3,0],[5,4,0],[5,5,0],[5,6,0],
            ];
            return {
                option:{
                    tooltip: {
                        position: 'top',
                    },
                    animation: false,
                    grid: {
                        // show:true,
                        // borderWidth:20,
                        height: '90%',
                        top: '10%',
                        // left: '20%',
                        width:'75%',
                        right:'3%'
                    },
                    xAxis: {
                        type: 'category',
                        data: ['第二天','第三天','第四天','第五天','第六天','第七天'],
                        position:"top",
                        axisLine:{
                            show:false,
                        },
                        axisTick:{
                            show:false,
                        },
                        splitArea: {
                            show: true,
                        },
                        axisLabel:{
                            interval:0,
                            fontSize:11
                        }
                    },
                    yAxis: {
                        type: 'category',
                        data: ['2020/05/31','2020/06/01','2020/06/02','2020/06/03','2020/06/04','2020/06/05','2020/06/06'],
                        splitArea: {
                            show: true
                        },
                        axisLine:{
                            show:false
                        },
                        axisTick:{
                            show:false,
                        },
                        inverse:true,
                        axisLabel:{
                            interval:0,
                            fontSize:11,
                        }
                    },
                    visualMap: {
                        min: 0,
                        max: 30,
                        calculable: true,
                        orient: 'horizontal',
                        left: 'center',
                        show:false,
                        inRange: {
                            color: ['#F2F2F2', '#5291FF'],
                        },
                        // bottom: '15%'
                    },
                    series: [{
                        name: '新增留存',
                        type: 'heatmap',
                        data: data,
                        label: {
                            show: true,
                            formatter:function (params) {
                                return params.value[2] + '%'
                            }
                        },
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowColor: 'rgba(0, 0, 0, 0.5)'
                            }
                        }
                    }]
                }
            }
        }
    }
</script>

<style scoped>
    .echarts{
        width: 100%;
        height: 100%;
    }
</style>